<template>
  <div class="app-container">
    <!-- 页面标题 -->
    <!-- <el-page-header content="出货任务详情" @back="goBack">
      <el-button slot="extra" type="text" icon="el-icon-arrow-left" @click="goBack">
        返回
      </el-button>
    </el-page-header> -->

    <!-- 加载中状态 -->
    <el-loading v-if="loading" fullscreen text="正在加载数据..."></el-loading>

    <!-- 数据为空提示 -->
    <el-empty v-if="!loading && !taskData.length" description="暂无任务数据"></el-empty>

    <!-- 任务详情内容（循环渲染） -->
    <div v-for="(item, index) in taskData" :key="index" v-if="item && item.task">
      <!-- 任务信息卡片 -->
      <el-row :gutter="24" style="background: #fff; margin: 0; padding: 20px;">
        <!-- 任务信息行 + 勾选框 -->
        <el-col :span="24" style="margin-bottom: 20px;">
          <el-checkbox v-model="item.task.selected" class="mr-2" @change="handleTaskCheckAll(item)"></el-checkbox>
          任务信息
        </el-col>
        <el-col :span="24" style="margin-bottom: 20px;">
          任务编号:<span>{{ item.task.taskCode || '暂无' }}</span>
        </el-col>
        <!-- 供应商信息行 -->
        <el-col :span="24" style="margin-bottom: 20px;">
          供应商:<span>{{ item.task.supplier || '暂无' }}</span>
        </el-col>

        <!-- 配送点信息行 + 添加商品按钮 -->
        <el-col :span="24" style="margin-bottom: 20px;">
          配送点: <span>{{ item.task.ydppName || '暂无' }}</span>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            class="ml-4"
            @click="openAddGoodsModal(item, index)"
          >
            添加商品
          </el-button>
        </el-col>
      </el-row>

      <!-- 商品列表表格 -->
      <el-card shadow="hover" class="mb-6">
        <div class="table-header flex justify-between items-center mb-4">
          <h2 class="el-heading el-heading--medium">商品清单</h2>
          <div>
            <el-button type="text" icon="el-icon-refresh" @click="refreshGoodsList(item)" title="刷新"></el-button>
            <el-button type="text" icon="el-icon-download" @click="exportGoodsList(item)" title="导出"></el-button>
          </div>
        </div>

        <page-table
          rowKey="goodsCode"
          :list="{rows: item.goodsList || []}"
          :fieldList="getFieldList2(item.task.taskType)"
          deleteName="id"
          :btns="['handle']"
          :handleSlot="true"
        >
          <template v-slot:col-num1="scope">
            <span>{{ scope.row.num }}</span>
            件
          </template>
          <template v-slot:col-wornNum="scope">
            <span v-if="isProductionTime(scope.row, item.task) && isExitType(item.task.taskType)">{{
                scope.row.wornNum
              }}</span>
            <el-input
              v-else
              @mousewheel.native.prevent
              style="width: 75px!important"
              type="number"
              v-model="scope.row.wornNum"
              :oninput="`if(value<0){value=0}else{value=parseInt(value)}`"
            ></el-input>
            件
          </template>
          <template v-slot:col-inventory="scope">
            <div class="inventory">

              <div>{{ scope.row.inventory }}{{ scope.row.minUnitName }}</div>
              <div>({{ Math.floor(scope.row.inventory / (scope.row.box || 1)) }}{{
                  scope.row.maxUnitName
                }}{{ scope.row.inventory % (scope.row.box || 1) }}{{ scope.row.minUnitName }})
              </div>
            </div>
          </template>
          <template v-slot:col-unavailable="scope">
            <div class="inventory">
              <div>{{ scope.row.unavailable }}{{ scope.row.minUnitName }}</div>
              <div>({{ Math.floor(scope.row.unavailable / (scope.row.box || 1)) }}{{
                  scope.row.maxUnitName
                }}{{ scope.row.unavailable % (scope.row.box || 1) }}{{ scope.row.minUnitName }})
              </div>
            </div>
          </template>

          <template v-slot:handleSlot="scope">

            <div class="handle-btn action-btn-container">
              <!-- 选择生产日期按钮 -->
              <el-button
                type="text"
                @click="openProductionDateModal(item, index, scope.row, scope.index)"

              >
                选择生产日期
              </el-button>

              <!--              <el-button-->
              <!--                type="text"-->
              <!--                @click="editShelvesWarehouse(item, index, scope.index)"-->
              <!--              >-->
              <!--                修改库位号-->
              <!--              </el-button>-->
              <el-button
                type="text"
                @click="deleteMember(item, index, scope.index)"
              >
                删除
              </el-button>
            </div>
          </template>
        </page-table>

        <!-- 表格底部统计 -->
        <div style="display:flex; margin-top: 10px" v-if="item.goodsList && item.goodsList.length">
          <label style="margin-left: auto; color: #696969;">
            计划总数：SKU种数{{ item.goodsList.length }}，共{{ getSkuTotal(item.goodsList) }}件
          </label>
        </div>
      </el-card>
    </div>

    <!-- 底部操作按钮 -->
    <div class="flex justify-end gap-4 mb-8 fixed-button" v-if="taskData.length">
      <!-- <el-button type="default" @click="cancelTask">取消</el-button> -->
      <el-button
        type="primary"
        icon="el-icon-check"
        @click="completeTask"
        :disabled="!hasSelectedGoods()"
      >
        完成出货
      </el-button>
    </div>

    <!-- 1. 添加商品弹窗 -->
    <el-dialog
      title="添加商品"
      :visible.sync="addGoodsModalVisible"
      width="90%"
      :show-close="false"
    >
      <el-row style="margin-bottom: 20px">
        <el-col :span="15">
          <el-input
            style="width: 180px!important; margin-right: 10px;"
            clearable
            v-model="dialogSearch.name"
            placeholder="请输入商品名称"
          ></el-input>
          <el-input
            style="width: 180px!important"
            clearable
            v-model="dialogSearch.goodsCode"
            placeholder="输入商品编码"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="getGoodsList()">查询</el-button>
        </el-col>
      </el-row>

      <page-table
        ref='pageTable'
        permission="lessionTable"
        :list="assignmentAddList"
        :fieldList="fieldList1"
        :selection="true"
        deleteName="id"
        :reserveSelection="true"
        :selectable="(row) => selectable(row, currentTaskIndex)"
        rowKey="goodsCode"
      >
        <template v-slot:col-inventory="scope">
          <div>{{ scope.row.inventory }}{{ scope.row.minUnitName }}</div>
          ({{ Math.floor(scope.row.inventory / (scope.row.box || 1)) }}{{
            scope.row.maxUnitName
          }}{{ scope.row.inventory % (scope.row.box || 1) }}{{ scope.row.minUnitName }})
        </template>
        <template v-slot:col-unavailable="scope">
          <div>{{ scope.row.unavailable }}{{ scope.row.minUnitName }}</div>
          ({{ Math.floor(scope.row.unavailable / (scope.row.box || 1)) }}{{
            scope.row.maxUnitName
          }}{{ scope.row.unavailable % (scope.row.box || 1) }}{{ scope.row.minUnitName }})
        </template>
      </page-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAddGoodsModal()">取消</el-button>
        <el-button type="primary" @click="confirmAddGoods()">确定</el-button>
      </div>
    </el-dialog>

    <!-- 2. 生产日期选择弹窗 -->
    <el-dialog
      :title="productionDateDialog.title"
      :visible.sync="productionDateDialog.visible"
      width="70%"
      :show-close="false"
    >
      <el-table
        :data="productionFormInfo"
        border
        style="width: 100%; margin-bottom: 20px;"
      >
        <el-table-column
          min-width="300px"
          prop="ytgbProductionTime"
          label="生产日期"
        >
          <template slot-scope="scope">
            <div class="flexCenter">
              <el-select
                v-model="scope.row.ytgbProductionTime"
                placeholder="请选择"
                @change="(value)=>{handleProductionTimeChange(value,scope.row, scope.index)}"
              >
                <el-option
                  v-for="(item, index) in getGoodsBatchDisabledSelect[scope.$index] || []"
                  :key="index"
                  :label="item.productionTime"
                  :value="item.productionTime"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
              <i
                class="el-icon-circle-plus-outline"
                v-if="scope.$index === 0"
                @click="addProductionTimeRow(scope.row)"
              ></i>
              <i
                class="el-icon-remove-outline"
                v-else
                @click="deleteProductionTimeRow(scope.$index)"
              ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="200px"
          align="center"
          prop="ysdgValidityTime"
          label="有效期至"

        >
          <template slot-scope="scope">
            <span :style="isOverdueList[scope.$index] ? 'color:red' : ''">
              {{ getExpDays[scope.$index] ? getExpDays[scope.$index].ysdgValidityTime : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="inventory"
          label="可用库存"
        >
          <template slot-scope="scope">
            <p>{{ getExpDays[scope.$index] ? getExpDays[scope.$index].inventory : 0 }}{{ scope.row.minUnitName }}</p>
            <p style="color: #aaa">
              ({{
                parseInt((getExpDays[scope.$index] ? getExpDays[scope.$index].inventory : 0) / (currentGoodsInfo.box || 1))
              }}{{ currentGoodsInfo.maxUnitName }}
              {{
                parseInt((getExpDays[scope.$index] ? getExpDays[scope.$index].inventory : 0) % (currentGoodsInfo.box || 1))
              }}{{ currentGoodsInfo.minUnitName }})
            </p>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="unavailable"
          label="不可用库存"
        >
          <template slot-scope="scope">
            <p>{{ getExpDays[scope.$index] ? getExpDays[scope.$index].unavailable : 0 }}{{ scope.row.minUnitName }}</p>
            <p style="color: #aaa">
              ({{
                parseInt((getExpDays[scope.$index] ? getExpDays[scope.$index].unavailable : 0) / (currentGoodsInfo.box || 1))
              }}{{ currentGoodsInfo.maxUnitName }}
              {{
                parseInt((getExpDays[scope.$index] ? getExpDays[scope.$index].unavailable : 0) % (currentGoodsInfo.box || 1))
              }}{{ currentGoodsInfo.minUnitName }})
            </p>
          </template>
        </el-table-column>
        <el-table-column
          min-width="200px"
          prop="ytgbNormal"
          label="计划数量（正常品）"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.ytgbNormal"
              placeholder="请输入"
              @blur="checkNumber('ytgbNormal', scope.$index, scope.row.ytgbNormal)"
            >
              <template slot="append">{{ currentGoodsInfo.minUnitName }}</template>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          v-if="isExitType(currentTaskInfo.task && currentTaskInfo.task.taskType)"
          min-width="200px"
          prop="ytgbBroken"
          label="计划数量（破损品）"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.ytgbBroken"
              placeholder="请输入"
              @blur="checkNumber('ytgbBroken', scope.$index, scope.row.ytgbBroken)"
            >
              <template slot="append">{{ currentGoodsInfo.minUnitName }}</template>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          min-width="300px"
          prop="yaId"
          label="库区"
        >
          <template slot-scope="scope">
            <el-select v-model="scope.row.yaId" placeholder="请选择库区"
                       @change="(value)=>{areaChange(value,scope.row)}">
              <el-option
                v-for="(item, index) in getWarehouseAreaOption[scope.row.goodsCode][scope.row.ytgbProductionTime]"
                :key="index" :label="item.yaName"
                :value="item.yaId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          min-width="300px"
          prop="ylId"
          label="库位号"
        >
          <template slot-scope="scope">
            <el-select v-model="scope.row.ylId" placeholder="请选择库位号">
              <el-option
                v-for="(item, index) in getLocationChildrenOption[scope.row.goodsCode][scope.row.ytgbProductionTime]"
                :key="index" :label="item.ylCode"
                :value="item.ylId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          min-width="200px"
          prop="picking"
          label="可拣数量"
        >
          <template slot-scope="scope">
            <el-input
              v-model="getPikingOption[scope.row.goodsCode][scope.row.ytgbProductionTime][scope.row.ylId]"
              readonly
            >
              <template slot="append">{{ currentGoodsInfo.minUnitName }}</template>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          min-width="200px"
          prop="pickingNum"
          label="拣货数量"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.pickingNum"
              placeholder="请输入"
              @blur="checkNumber('pickingNum', scope.$index, scope.row.pickingNum)"
            >
              <template slot="append">{{ currentGoodsInfo.minUnitName }}</template>
            </el-input>
          </template>
        </el-table-column>
      </el-table>

      <p style="text-align: right; margin-top: 20px; font-size: 16px;">
        合计：正常品{{ productionTotal[0] }}件，破损品{{ productionTotal[1] }}件
      </p>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeProductionDateModal()">取消</el-button>
        <el-button type="primary" @click="confirmProductionDate()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageTable from '@/components/Table/Index'
import assignmentManage from '@/store/assignmentManage/index'
import {
  editTask,
  finishForPicking,
  GETGOODSBATCH,
  getStatus6TaskDetails,
  TASKGETGOODS
} from '@/store/assignmentManage/types'
import user from '@/store/user/index'
import {DICTGETCHILDS} from '@/store/goodsManage/types.js'
import http from '../../../utils/http'

export default {
  name: 'ShipmentTaskDetail',
  components: {
    pageTable
  },
  data () {
    return {
      // 基础加载状态
      loading: true,
      taskData: [], // 任务列表
      // 添加商品弹窗相关
      addGoodsModalVisible: false,
      dialogSearch: {name: '', goodsCode: ''},
      currentTaskInfo: {}, // 初始化为空对象而非null
      currentTaskIndex: -1, // 当前任务索引
      // 生产日期弹窗相关
      productionDateDialog: {
        title: '选择生产日期',
        visible: false
      },
      currentGoodsInfo: {}, // 初始化为空对象
      currentGoodsIndex: -1, // 当前商品在任务中的索引
      productionFormInfo: [
        {
          ytgbProductionTime: '',
          ytgbNormal: 0,
          ytgbBroken: 0,
          minUnitName: '',
          goodsCode: '',
          warehouseCode: '',
          ylId: '',
          yaId: '',
          picking: '',
          index: 1
        }
      ],
      isOverdueGoodsList: {}, // 过期商品列表
      // 其他
      warehouseCode: '',
      warehouseAreaOption: {
        '空': {
          '空': []
        }
      },
      locationOption: {},
      locationChildrenOption: {
        '空': {
          '空': []
        }
      },
      currentYlId: null,
      picking: {
        '空': {
          '空': {
            '空': 0
          }
        }
      }
    }
  },
  computed: {
    // 商品选择列表（从store获取）
    assignmentAddList () {
      return assignmentManage.state.assignmentAddList || []
    },
    editTaskList () {
      return assignmentManage.state.editTaskList
    },
    finishForPickingList () {
      return assignmentManage.state.finishForPickingList
    },
    // 用户信息
    userinfo () {
      return user.state.userinfo || {}
    },
    // 商品批次列表（生产日期下拉）
    goodsBatchSelect () {
      return assignmentManage.state.goodsBatchSelect || []
    },
    // 表格列配置1（添加商品弹窗）
    fieldList1 () {
      let arr = [
        {label: '商品名称', prop: 'name', width: 150},
        {label: '商品属性', prop: 'typeName', width: 150},
        {label: '规格', prop: 'standard', width: 150},
        {label: '箱规（件/箱）', prop: 'box', width: 150},
        {label: '可用库存', prop: 'inventory', width: 150, type: 'slot'},
        {label: '不可用库存', prop: 'unavailable', width: 150, type: 'slot'},
        {label: '商品编码', prop: 'goodsCode', width: 150},
        {label: '供应商', prop: 'supplier', width: 150}
      ]
      // 开启生产日期管理时添加保质期列
      if (this.userinfo.isMdOpen === 1) {
        arr.splice(4, 0, {label: '保质期（天）', prop: 'expDays', width: 150})
      }
      return arr
    },
    // 生产日期下拉（禁用已选）
    getGoodsBatchDisabledSelect () {
      let list = []
      let ids = this.productionFormInfo.map(item => item.ytgbProductionTime)
      this.productionFormInfo.forEach(item => {
        let arr = []
        this.goodsBatchSelect.forEach(v => {
          if (ids.indexOf(v.productionTime) > -1) {
            arr.push({...v, disabled: true})
          } else {
            arr.push(v)
          }
        })
        list.push(arr)
      })
      return list
    },
    getWarehouseAreaOption () {
      return this.warehouseAreaOption
    },
    getLocationChildrenOption () {
      return this.locationChildrenOption
    },
    getPikingOption () {
      return this.picking
    },
    // 有效期至计算
    getExpDays () {
      let list = []
      this.productionFormInfo.forEach((item, index) => {
        if (item.ytgbProductionTime) {
          let result = {}
          // 替换find为循环，避免空数组报错
          for (let i = 0; i < this.goodsBatchSelect.length; i++) {
            if (this.goodsBatchSelect[i].productionTime === item.ytgbProductionTime) {
              result = this.goodsBatchSelect[i]
              break
            }
          }
          list.push({
            ysdgValidityTime: (this.currentGoodsInfo.expDays === 0 || item.ytgbProductionTime === '无')
              ? '-'
              : this.getDateStr(item.ytgbProductionTime, this.currentGoodsInfo.expDays || 0),
            inventory: result.normal || 0,
            unavailable: result.broken || 0
          })
        } else {
          list.push({
            ysdgValidityTime: '',
            inventory: 0,
            unavailable: 0
          })
        }
      })
      return list
    },
    // 过期判断
    isOverdueList () {
      let arr = []
      this.productionFormInfo.forEach((_, index) => {
        let isOverdue = false
        if (this.getExpDays[index] && this.getExpDays[index].ysdgValidityTime && this.getExpDays[index].ysdgValidityTime !== '-') {
          let itemDate = new Date(this.getExpDays[index].ysdgValidityTime).getTime()
          let nowDate = new Date(this.getCurrentDate()).getTime()
          isOverdue = nowDate > itemDate
        }
        arr.push(isOverdue)
      })
      return arr
    },
    // 生产日期合计
    productionTotal () {
      let list = [0, 0]
      this.productionFormInfo.forEach(item => {
        list[0] += parseInt(item.ytgbNormal) || 0
        list[1] += parseInt(item.ytgbBroken) || 0
      })
      return list
    }
  },
  watch: {
    editTaskList: {
      deep: true,
      handler (val) {
        this.fetchTaskData()
        console.log(val)
      }
    },
    finishForPickingList: {
      deep: true,
      handler (val) {
        this.fetchTaskData()
        console.log(val)
      }
    }
  },
  created () {
    // 初始化仓库编码
    this.warehouseCode = this.$route.params.warehouseCode || ''
    // 获取任务详情
    this.fetchTaskData()
    // 获取字典数据
    this.$store.dispatch(DICTGETCHILDS, {parentCode: 'TASK_TYPE'}).catch(err => {
      console.error('获取字典数据失败:', err)
    })
  },
  methods: {
    // ========== 基础方法 ==========
    // 获取任务数据
    fetchTaskData () {
      this.loading = true
      try {
        let list = assignmentManage.state.getStatus6TaskDetailsList || []
        if (list.length === 0) {
          http.fetch('/api/task/getStatus6TaskDetails').then(res => {
            if (res.code === 200) {
              list = res.obj
              this.taskData = list.map(item => {
                let task = item.task || {}
                let goodsList = item.goodsList || []
                this.$store.dispatch('BATCH_TASK_SET_DATE', list)
                return {
                  task: task,
                  goodsList: goodsList,
                  ...item
                }
              })
            } else {
              this.$message.error('获取任务数据失败')
            }
          })
        }
      } catch (e) {
        this.$message.error('获取任务数据失败')
        console.error(e)
        this.taskData = [] // 异常时重置为空数组
      } finally {
        this.loading = false
      }
    },
    // 返回上一页
    goBack () {
      this.$router.go(-1)
    },
    // 获取今天日期（YYYY-MM-DD）
    getCurrentDate () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    // 获取N天后的日期
    getDateStr (today, addDayCount) {
      if (!today) return ''
      const dd = new Date(today)
      dd.setDate(dd.getDate() + addDayCount)
      const y = dd.getFullYear()
      const m = String(dd.getMonth() + 1).padStart(2, '0')
      const d = String(dd.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    // 计算SKU总数
    getSkuTotal (goodsList) {
      if (!Array.isArray(goodsList)) return 0
      return goodsList.reduce(function (sum, item) {
        return sum + (parseInt(item.num1) || 0) + (parseInt(item.wornNum) || 0)
      }, 0)
    },
    // 判断是否为空场/其他出库任务
    isExitType (taskType) {
      return ['TASK_TYPE_EMPTY', 'TASK_TYPE_OTHER_OUT'].indexOf(taskType) > -1
    },
    // 动态生成fieldList2（避免依赖currentTaskInfo）
    getFieldList2 (taskType) {
      let ary = [
        {label: '商品名称', prop: 'name', width: 150},
        {label: '商品属性', prop: 'typeName', width: 150},
        {label: '规格', prop: 'standard', width: 150},
        {label: '箱规（件/箱）', prop: 'box', width: 150},
        {label: '可用库存', prop: 'inventory', width: 150, type: 'slot'},
        {label: '不可用库存', prop: 'unavailable', width: 150, type: 'slot'},
        {label: '计划数量（正常品）', prop: 'num1', width: 250, type: 'slot'},
        {label: '计划数量（破损品）', prop: 'wornNum', width: 250, type: 'slot'},
        {label: '商品条码', prop: 'barCode', width: 150},
        {label: '商品编码', prop: 'goodsCode', width: 150},
        {label: '供应商', prop: 'supplier', width: 150},
        {label: '库位号', prop: 'goodsShelvesWarehouseAddressNames', width: 150}
      ]
      // 非空场/其他出库任务隐藏破损品列
      if (!this.isExitType(taskType)) {
        ary.splice(7, 1)
      }
      return ary
    },

    // ========== 添加商品弹窗相关 ==========
    // 打开添加商品弹窗
    openAddGoodsModal (taskItem, index) {
      if (!taskItem || !taskItem.task) {
        this.$message.warning('任务数据异常，无法添加商品')
        return
      }
      this.currentTaskInfo = taskItem
      this.currentTaskIndex = index
      this.dialogSearch = {name: '', goodsCode: ''}
      this.addGoodsModalVisible = true

      // 初始化商品列表
      this.getGoodsList()
    },
    // 获取商品列表
    getGoodsList () {
      console.log(this.currentTaskInfo.task, '')

      // 替换?.为ES5判断
      if (!this.currentTaskInfo || !this.currentTaskInfo.task) return
      const params = {
        supplierCode: this.currentTaskInfo.task.supplierCode || '',
        type: this.currentTaskInfo.task.taskType || '',
        name: this.dialogSearch.name || '',
        goodsCode: this.dialogSearch.goodsCode || '',
        warehouseCode: this.currentTaskInfo.task.warehouseCode
      }
      this.$store.dispatch(TASKGETGOODS, params).then(() => {
        // 回显已选商品
        this.$nextTick(() => {
          this.setTableSelection()
        })
      }).catch(function (err) {
        console.error('获取商品列表失败:', err)
        this.$message.error('获取商品列表失败')
      }.bind(this))
    },
    // 设置表格选中状态
    setTableSelection () {
      // 多层级空值判断
      if (!this.$refs.pageTable) return
      if (!this.$refs.pageTable.$refs.table) return
      if (!this.currentTaskInfo) return
      if (!this.currentTaskInfo.goodsList) return

      const table = this.$refs.pageTable.$refs.table
      const goodsList = this.currentTaskInfo.goodsList
      goodsList.forEach(function (item) {
        table.toggleRowSelection(item, true)
      })
    },
    // 表格行是否可选择
    selectable (row, taskIndex) {
      if (taskIndex === -1) return true
      if (!this.taskData[taskIndex]) return true
      if (!this.taskData[taskIndex].goodsList) return true

      const goodsCodes = []
      this.taskData[taskIndex].goodsList.forEach(function (item) {
        goodsCodes.push(item.goodsCode)
      })
      return goodsCodes.indexOf(row.goodsCode) === -1
    },
    // 关闭添加商品弹窗
    closeAddGoodsModal () {
      this.addGoodsModalVisible = false
      if (this.$refs.pageTable && this.$refs.pageTable.$refs.table) {
        this.$refs.pageTable.$refs.table.clearSelection()
      }
    },
    // 确认添加商品
    confirmAddGoods () {
      if (!this.$refs.pageTable || !this.$refs.pageTable.$refs.table) {
        this.$message.warning('未选择商品')
        return
      }
      const selection = this.$refs.pageTable.$refs.table.selection || []
      if (selection.length === 0) {
        this.$message.warning('请选择要添加的商品')
        return
      }

      // 合并商品到当前任务
      const currentGoodsCodes = []
      if (this.currentTaskInfo && this.currentTaskInfo.goodsList) {
        this.currentTaskInfo.goodsList.forEach(function (item) {
          currentGoodsCodes.push(item.goodsCode)
        })
      }

      const newGoods = []
      selection.forEach(function (item) {
        if (currentGoodsCodes.indexOf(item.goodsCode) === -1) {
          newGoods.push(item)
        }
      })

      if (newGoods.length > 0) {
        // 初始化商品默认值
        if (!this.currentTaskInfo.goodsList) {
          this.currentTaskInfo.goodsList = []
        }
        newGoods.forEach(function (item) {
          this.currentTaskInfo.goodsList.push({
            ...item,
            num1: 0,
            wornNum: 0,
            batchList: [],
            openStatus: item.openStatus || 0,
            box: item.box || 1, // 兜底箱规
            minUnitName: item.minUnitName || '件',
            maxUnitName: item.maxUnitName || '箱'
          })
        }.bind(this))
        this.$message.success('成功添加' + newGoods.length + '个商品')
      } else {
        this.$message.info('所选商品已全部存在于任务中')
      }

      this.closeAddGoodsModal()
    },
    clear () {
      // this.picking = {}
      // this.locationOption = {}
      // this.locationChildrenOption = {}
      // this.warehouseAreaOption = {}
    },

    // ========== 生产日期弹窗相关 ==========
    // 打开生产日期弹窗
    openProductionDateModal (taskItem, taskIndex, goodsItem, goodsIndex) {
      if (!taskItem || !taskItem.task || !goodsItem) {
        this.$message.warning('数据异常，无法选择生产日期')
        return
      }
      this.currentTaskInfo = taskItem
      this.currentTaskIndex = taskIndex
      this.currentGoodsInfo = goodsItem
      this.currentGoodsIndex = goodsIndex

      // 获取商品批次数据
      this.$store.dispatch(GETGOODSBATCH, {goodsCode: goodsItem.goodsCode}).then(function () {
        // 回显已有批次数据
        console.log(goodsItem.batchList, 'goodsItem.batchList', goodsItem, taskItem)
        console.log(goodsItem.batchList, 'goodsItem.batchList', goodsItem)
        let batchList = []
        if (goodsItem.batchList.length) {
          for (let i = 0; i < goodsItem.batchList.length; i++) {
            batchList.push({
              ytgbProductionTime: goodsItem.batchList[i].productionTime,
              ytgbBroken: goodsItem.batchList[i].unBroken,
              oldYtgbBroken: goodsItem.batchList[i].unBroken,
              ytgbNormal: goodsItem.batchList[i].normal,
              oldYtgbNormal: goodsItem.batchList[i].normal,
              goodsCode: goodsItem.goodsCode,
              ytgbId: goodsItem.batchList[i].ytgbId,
              oldYlId: goodsItem.batchList[i].oldYlId,
              ylId: goodsItem.batchList[i].oldYlId,
              oldYpgId: goodsItem.batchList[i].oldYpgId,
              yaId: goodsItem.batchList[i].oldYaId,
              oldYaId: goodsItem.batchList[i].oldYaId,
              pickingNum: goodsItem.batchList[i].normaled,
              warehouseCode: taskItem.task.warehouseCode
            })
          }
        }
        if (!goodsItem.batchList.length) {
          batchList = [{
            ytgbProductionTime: '',
            ytgbNormal: 0,
            ytgbBroken: 0,
            minUnitName: goodsItem.minUnitName || '',
            goodsCode: goodsItem.goodsCode,
            warehouseCode: taskItem.task.warehouseCode,
            index: 1
          }]
        }
        let promiseList = []
        batchList.forEach(e => {
          promiseList.push(this.initLocationOption(e, taskItem.goodsList[goodsIndex].goodsCode, taskItem.task.warehouseCode, e.ytgbProductionTime, taskItem.task.code))
        })
        Promise.all(promiseList).then(res => {
          this.productionFormInfo = JSON.parse(JSON.stringify(batchList))
          this.productionDateDialog.visible = true
        })
      }.bind(this)).catch(function (err) {
        console.error('获取商品批次失败:', err)
        this.$message.error('获取生产日期数据失败')
      }.bind(this))
    },
    areaChange (value, row) {
      let dataList = []
      this.locationOption[row.goodsCode][row.ytgbProductionTime].filter(location => {
        return location.yaId === value
      })[0].children.forEach(e => {
        dataList.push(e)
      })
      this.locationChildrenOption[row.goodsCode][row.ytgbProductionTime] = dataList
    },
    initLocationOption (row, goodsCode, warehouseCode, productionTime, taskCode) {
      return new Promise((resolve, reject) => {
        let params = {
          goodsCode: goodsCode,
          warehouseCode: warehouseCode,
          taskCode: taskCode,
          quality: 1,
          productionTime: productionTime
        }
        http.fetchNoMessage('/lyyc/batchPicking/getLocationList', params, 'application/json').then(res => {
          if (res.code === 200) {
            let data = res.obj
            this.warehouseAreaOption[params.goodsCode] = this.warehouseAreaOption[params.goodsCode] || {}
            this.warehouseAreaOption[params.goodsCode][productionTime] = data.map(e => {
              const {yaId, yaName} = e
              return {
                yaId: yaId,
                yaName: yaName
              }
            })
            this.locationOption[params.goodsCode] = this.locationOption[params.goodsCode] || {}
            this.locationOption[params.goodsCode][productionTime] = res.obj
            this.picking[params.goodsCode] = this.picking[params.goodsCode] || {}
            this.picking[params.goodsCode][productionTime] = this.picking[params.goodsCode][productionTime] || {}
            this.locationChildrenOption[params.goodsCode] = this.locationChildrenOption[params.goodsCode] || {}
            this.locationChildrenOption[params.goodsCode][productionTime] = this.locationChildrenOption[params.goodsCode][productionTime] || {}
            res.obj.forEach(e => {
              e.children.forEach(ec => {
                this.picking[params.goodsCode][productionTime][ec.ylId] = ec.picking
              })
            })
            console.log(this.warehouseAreaOption, 'this.warehouseAreaOption')
            console.log(this.locationOption, 'this.locationOption')
            console.log(this.picking, 'this.picking')

            console.log(this.locationChildrenOption, 'this.locationChildrenOption')
            if (row.oldYlId) {
              this.areaChange(row.oldYaId, row)
            }
          } else {
            this.$message.error(res.msg)
          }
          resolve(true)
          // eslint-disable-next-line handle-callback-err
        }).catch((err) => {
          resolve(true)
        })
      })
    },
    // 添加生产日期行
    addProductionTimeRow (row) {
      const hasEmpty = this.productionFormInfo.some(function (item) {
        return !item.ytgbProductionTime || item.ytgbNormal === '' || item.ytgbBroken === ''
      })
      if (hasEmpty) {
        this.$message.error('请先填写完整当前行数据')
        return
      }
      console.log('xxxxxxxxxvaasrer', row)
      this.picking[this.currentGoodsInfo.goodsCode] = this.picking[this.currentGoodsInfo.goodsCode] || {}
      this.picking[this.currentGoodsInfo.goodsCode]['空'] = this.picking[this.currentGoodsInfo.goodsCode]['空'] || {}
      this.picking[this.currentGoodsInfo.goodsCode]['空']['空'] = this.picking[this.currentGoodsInfo.goodsCode]['空']['空'] || 0
      this.productionFormInfo.push({
        goodsCode: this.currentGoodsInfo.goodsCode,
        warehouseCode: row.warehouseCode,
        pickingNum: 0,
        yaId: '',
        oldYlId: '',
        ylId: '空',
        ytgbProductionTime: '空',
        ytgbNormal: 0,
        ytgbBroken: 0,
        minUnitName: this.currentGoodsInfo.minUnitName || '',
        index: this.productionFormInfo.length + 1
      })
      console.log(this.productionFormInfo, 'xxxxxxxxxxxxxx')
    },
    // 删除生产日期行
    deleteProductionTimeRow (index) {
      this.productionFormInfo.splice(index, 1)
      // 重新计算索引
      this.productionFormInfo.forEach(function (item, i) {
        item.index = i + 1
      })
    },
    // 生产日期变更
    handleProductionTimeChange (value, row, index) {
      console.log('xxxxxxxxxxxxxxxxxxxxxx-value-date', value)
      console.log('xxxxxxxxxxxxxxxxxxxxxx-value-date', this.currentTaskInfo)
      // 联动更新单位
      row.minUnitName = this.currentGoodsInfo.minUnitName || ''
      this.picking[row.goodsCode] = this.picking[row.goodsCode] || {}
      this.picking[row.goodsCode][value] = this.picking[row.goodsCode][value] || {}
      this.picking[row.goodsCode][value]['空'] = this.picking[row.goodsCode][value]['空'] || 0
      this.productionFormInfo[index] = {
        ...row,
        yaId: '',
        ylId: ''
      }
      this.initLocationOption(row, row.goodsCode, row.warehouseCode,value, this.currentTaskInfo.task.code)
    },
    // 校验数字输入
    checkNumber (key, index, value) {
      if (value && this.productionFormInfo[index]) {
        this.productionFormInfo[index][key] = value.replace(/[^\d]/g, '')
      }
    },
    // 关闭生产日期弹窗
    closeProductionDateModal () {
      this.productionDateDialog.visible = false
      this.productionFormInfo = [
        {
          ytgbProductionTime: '',
          ytgbNormal: 0,
          ytgbBroken: 0,
          minUnitName: '',
          goodsCode: this.currentGoodsInfo.goodsCode,
          warehouseCode: this.currentTaskInfo.warehouseCode,
          index: 1
        }
      ]
      this.clear()
    },
    // 确认生产日期
    confirmProductionDate () {
      // 校m验数据完整性
      const hasEmpty = this.productionFormInfo.some(function (item) {
        return !item.ytgbProductionTime || item.ytgbNormal === '' || item.ytgbBroken === ''
      })
      if (hasEmpty) {
        this.$message.error('请填写完整所有行数据')
        return
      }

      // 校验库存
      const hasOverStock = this.productionFormInfo.some(function (item, index) {
        const expData = this.getExpDays[index] || {}
        console.log('expData=', expData, 'item', item)
        let isNormalChange = item.oldYtgbNormal !== item.ytgbNormal
        let isBrokenChange = item.oldYtgbBroken !== item.ytgbBroken
        if (!isNormalChange && !isBrokenChange) {
          return false
        }
        return parseInt(item.ytgbNormal) > expData.inventory || parseInt(item.ytgbBroken) > expData.unavailable
      }.bind(this))
      if (hasOverStock) {
        this.$message.error('计划数量不能超过可用库存')
        return
      }

      // 更新商品数据
      if (!this.taskData[this.currentTaskIndex]) return
      if (!this.taskData[this.currentTaskIndex].goodsList) return
      const targetGoods = this.taskData[this.currentTaskIndex].goodsList
      console.log(this.goodsBatchSelect, this.currentTaskInfo, this.currentGoodsInfo, this.currentGoodsIndex, 'this.currentGoodsIndex')
      var batchList = []
      var num = 0
      var goodsCode = ''
      console.log('productionFormInfo====',this.productionFormInfo,this.productionFormInfo.length)
      for (let i = 0; i < this.productionFormInfo.length; i++) {
        batchList.push({
          ytgbProductionTime: this.productionFormInfo[i].ytgbProductionTime,
          ytgbNormal: this.productionFormInfo[i].ytgbNormal,
          ytgbBroken: this.productionFormInfo[i].ytgbBroken || 0,
          index: this.productionFormInfo[i].index || 1,
          goodsCode: this.productionFormInfo[i].goodsCode,
          warehouseCode: this.productionFormInfo[i].warehouseCode,
          pickingNum: this.productionFormInfo[i].pickingNum,
          yaId: this.productionFormInfo[i].yaId,
          oldYlId: this.productionFormInfo[i].oldYlId,
          ylId: this.productionFormInfo[i].ylId
        })
        goodsCode = this.productionFormInfo[i].goodsCode
        const currentVal = Number(this.productionFormInfo[i].ytgbNormal) || 0
        num += currentVal
      }
      console.log(batchList, num, 'this.currentGoodsIndex')
      batchList = batchList.map(e => {
        if (e.ytgbProductionTime === '无') {
          e.ytgbProductionTime = null
        }
        return e
      })
      console.log(batchList, 'this.currentGoodsIndex111111111')

      let data = {
        goodsList: [{batchList, num: num, wornNum: 0, goodsCode}],
        taskCode: this.taskData[this.currentTaskIndex].task.code

      }
      console.log(data, 'this.currentGoodsIndex')
      // eslint-disable-next-line handle-callback-err
      this.$store.dispatch(editTask, data).then((res) => {
        console.log(res)
        if (targetGoods) {
          targetGoods.batchList = JSON.parse(JSON.stringify(this.productionFormInfo))
          targetGoods.num1 = 11
          targetGoods.wornNum = this.productionTotal[1]

          // 记录过期商品
          if (this.isOverdueList.indexOf(true) > -1) {
            this.isOverdueGoodsList[targetGoods.goodsCode] = targetGoods.name
          } else {
            delete this.isOverdueGoodsList[targetGoods.goodsCode]
          }

          this.$message.success('生产日期设置成功')
          this.fetchTaskData()
        }

        this.closeProductionDateModal()
      })
    },

    // ========== 商品列表操作 ==========
    // 删除商品
    deleteMember (taskItem, taskIndex, goodsIndex) {
      this.$confirm('确定要删除该商品吗？', '提示', {
        type: 'warning'
      }).then(function () {
        if (taskItem && taskItem.goodsList) {
          http.fetch('/api/ycTaskGoods/deleteGoods/' + taskItem.task.taskCode + '/' + taskItem.goodsList[goodsIndex].goodsCode + '/' + taskItem.task.warehouseCode).then(res => {
            if (res.code === 200) {
              taskItem.goodsList.splice(goodsIndex, 1)
              this.$message.success('删除成功')
            } else {
              this.$message.success('删除失败')
            }
          })
        }
      }.bind(this))
    },
    // 判断是否需要显示生产日期选择
    isProductionTime (row, task) {
      if (!row || !task) return false
      let identity = window.localStorage.getItem('identity')
      if (identity !== '1') {
        return row.openStatus === 1 && task.nature === '1'
      }
      return row.openStatus === 1 && (this.userinfo.isMdOpen === 1) && task.nature === '1'
    },

    // ========== 任务操作 ==========
    // 任务全选/取消全选
    handleTaskCheckAll (taskItem) {
      if (!taskItem || !taskItem.task || !taskItem.goodsList) return
      const isChecked = taskItem.task.selected
      taskItem.goodsList.forEach(function (goods) {
        goods._selected = isChecked
      })
    },
    // 刷新商品列表
    refreshGoodsList (taskItem) {
      this.$message.info('正在刷新商品列表...')
      // 实际项目中重新请求该任务的商品数据
      setTimeout(function () {
        this.$message.success('商品列表已刷新')
      }.bind(this), 800)
    },
    // 导出商品列表
    exportGoodsList (taskItem) {
      this.$message.info('正在导出商品清单...')
    },
    // 取消任务
    cancelTask () {
      this.$confirm('确定要取消当前出货任务吗？', '提示', {
        type: 'warning'
      }).then(function () {
        this.$router.push('/task/list')
        this.$message.success('任务已取消')
      }.bind(this))
    },
    // 判断是否有选中商品
    hasSelectedGoods () {
      let hasSelected = false
      for (let i = 0; i < this.taskData.length; i++) {
        let taskItem = this.taskData[i]
        console.log(taskItem, 'taskItem')

        if (!taskItem || !taskItem.goodsList) continue
        for (let j = 0; j < taskItem.goodsList.length; j++) {
          let goods = taskItem.goodsList[j]
          if (goods._selected) {
            hasSelected = true
            break
          }
        }
        if (hasSelected) break
      }
      return hasSelected
    },
    // 完成任务
    completeTask () {
      // 收集选中数据（简化版，可根据实际需求扩展）
      const selectedGoods = []
      this.taskData.forEach(function (taskItem) {
        console.log(taskItem, taskItem.goodsListz, 'taskItem && taskItem.goodsListz')

        if (taskItem && taskItem.goodsList) {
          taskItem.goodsList.forEach(function (goods) {
            if (goods._selected) {
              selectedGoods.push(goods)
            }
          })
        }
      })
      console.log(selectedGoods, 'selectedGoods')

      if (selectedGoods.length === 0) {
        this.$message.warning('请选择要完成出货的商品')
        return
      }

      // 检查过期商品
      const overdueGoods = []
      for (let key in this.isOverdueGoodsList) {
        overdueGoods.push(this.isOverdueGoodsList[key])
      }
      if (overdueGoods.length > 0) {
        this.$confirm('选中商品包含过期商品：' + overdueGoods.join('、') + '，是否继续完成出货？', '提示', {
          type: 'warning'
        }).then(function () {
          this.submitCompleteTask(selectedGoods)
        }.bind(this))
        return
      }

      this.submitCompleteTask(selectedGoods)
    },
    // 提交完成任务
    submitCompleteTask (selectedGoods) {
      this.loading = true
      // 模拟接口提交
      for (let i = 0; i < this.taskData.length; i++) {
        if (this.taskData[i].task.selected) {
          this.$store.dispatch(finishForPicking, {code: this.taskData[i].task.code})
        }
      }
      // setTimeout(function() {
      //   this.loading = false
      //   this.$message.success('出货任务已成功完成！')
      //   console.log(selectedGoods,'selectedGoods');

      //   // setTimeout(function() {
      //   //   this.$router.push("/task/list")
      //   // }.bind(this), 1500)
      // }.bind(this), 1000)
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.inventory {
  line-height: 1.5;
}

.flexCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-icon-remove-outline,
.el-icon-circle-plus-outline {
  font-size: 24px;
  color: #409EFF;
  margin-left: 6px;
  cursor: pointer;
}

.dialog-footer {
  text-align: center;
}

.mr-2 {
  margin-right: 8px;
}

.ml-4 {
  margin-left: 16px;
}

.mb-6 {
  margin-bottom: 24px;
}

.mb-8 {
  margin-bottom: 32px;
}

.gap-4 {
  gap: 16px;
}

.justify-between {
  justify-content: space-between;
}

.justify-end {
  justify-content: flex-end;
}

.items-center {
  align-items: center;
}

.flex {
  display: flex;
}

/* 操作列按钮容器：核心换行样式 */
.action-btn-container {
  display: flex;
  flex-wrap: wrap; /* 关键：自动换行 */
  gap: 4px; /* 按钮之间的间距，比margin更优雅 */
  justify-content: center; /* 按钮水平居中 */
  padding: 4px 0; /* 上下内边距，避免按钮贴表格线 */
}

/* 穿透修改Element固定列的默认样式：移除强制不换行 */
::v-deep .action-fixed-column {
  white-space: normal !important; /* 覆盖Element的white-space: nowrap */
}

/* 修复固定列表格单元格的内边距，避免内容挤压 */
::v-deep .action-fixed-column .el-table-cell {
  padding: 8px 4px !important;
  box-sizing: border-box;
}

.fixed-button {
  position: fixed; /* 固定定位 */
  bottom: 10px; /* 距离底部 10px */
  right: 10px; /* 距离右侧 10px */
}
</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/warehouse/bulkPracticingOfGoods.vue